import { DatePipe } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { EntitiesServiceService } from '../../../../../services/entities-service.service';

@Component({
  selector: 'app-activity-level',
  templateUrl: './activity-level.component.html',
  styleUrls: ['./activity-level.component.css']
})
export class ActivityLevelComponent implements OnInit, OnDestroy {
  @Input() entityId: any;
  @Input() widgetData: any;
  isError: boolean = false;
  isloader: boolean = false;
  startTime: Date = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0, 999);
  activitylevelList: any[] = [];
  activityLevelData: any;
  sourceTimestamp: any;
  donutColor: any;

  private _subscription: Subscription;
  private _startTime: any;
  private _today: any = new Date();
  private _intervalTimer: any;
  private _donutColor: any;
  private _endTime: Date;
  private _attributeDataSubscription: Subscription;

  constructor(private _service: EntitiesServiceService, private _sharedService: ServicecallService, private _datePipe: DatePipe, private _dataSer: DataService) {
    this._subscription = _dataSer.events.subscribe((res: any) => {
      if (res.name === 'siteChanged' || res.name === 'apiRefresh') {
        this._getActivityLevel();
      }
    });
  }

  ngOnInit(): void {
  }

  ngOnChanges(): void {
    this._getActivityLevel();
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
    this._clearTimer();
  }

  private _refreshApi() {
    if (+this.widgetData?.refreshRate) {
      this._clearTimer();
      this._intervalTimer = setInterval(() => {
        this._getActivityLevel();
      }, +this.widgetData?.refreshRate);
      this.isError = false;
    }
  }

  private _clearTimer() {
    if (this._intervalTimer) {
      clearInterval(this._intervalTimer);
    }
  }

  private _getActivityLevel() {
    const reqData = {
      from: this._datePipe.transform(this._startTime, 'yyyy-MM-ddTHH:mm:ssZZ'),
      to: this._datePipe.transform(Date.now(), 'yyyy-MM-ddTHH:mm:ssZZ'),
      entityId: this.entityId,
      siteId: this._sharedService.getSiteId()
    }

    // const dummy = [
    //   {
    //     "attributeName": "Battery",
    //     "attributeValue": "155.0",
    //     "condition": "Charged"
    //   },
    //   {
    //     "attributeName": "Skin Temperature °C",
    //     "attributeValue": "-26.0"
    //   },
    //   {
    //     "attributeName": "Respiratory Rate",
    //     "attributeValue": "14"
    //   },
    //   {
    //     "attributeName": "Activity",
    //     "attributeValue": "-76.0",
    //     "condition": "Inactive"
    //   },
    //   {
    //     "attributeName": "Flag",
    //     "attributeValue": "6.0"
    //   }
    // ]
    // this.activityLevelData = dummy?.find((item: any) => item.attributeName === "Activity");
    this._attributeDataSubscription = this._service.attributeData(reqData).subscribe(
      {
        next: (result: any) => {
          if (result.status && result.response.data?.length) {
            this.activityLevelData = result?.response?.data?.find((item: any) => item.attributeName === "Activity");
            this.sourceTimestamp = this.activityLevelData?.sourceTimestamp ? this._sharedService.getLastSeenFormat(this.activityLevelData?.sourceTimestamp) : null;
            if (+this.activityLevelData?.attributeValue >= 50) {
              this._donutColor = '#008500';
            } else if (+this.activityLevelData?.attributeValue < 50 && +this.activityLevelData?.attributeValue > 5) {
              this._donutColor = '#D08B4B';
            } else {
              this._donutColor = '#DD1A31';
            }
            this._activityLevel();
          } else {
            this.activityLevelData = {};
          }
          this.isloader = false;
          this._refreshApi();
        },
        error: (error) => {
          if (error) {
            this.isloader = false;
            this.isError = true;
            this._refreshApi();
          }
        }
      }
    )
  }
  private _activityLevel() {
    this.activitylevelList = [];
    let donut = [{
      values: [Math.abs(this.activityLevelData?.attributeValue), 100 - Math.abs(this.activityLevelData?.attributeValue)], labels: ['', ''],

      type: 'pie', textinfo: 'none', title: "", hole: .8, legend: false, marker: { colors: [this._donutColor, ' #F2F1F1'] }, barColor: 'white'
    }];
    this.activitylevelList.push(donut);
  }

}
